const LANGUAGE_ZHT_ALIAS = 'zh-Hant';
const LANGUAGE_ZHT = 'zht';
const LANGUAGE_ZH_ALIAS = 'zh-Hans';
const LANGUAGE_ZH = 'zh';
const LANGUAGE_EN = 'en';
const LANGUAGE_KO = 'ko';
const LANGUAGE_JA = 'ja';
const LANGUAGE_VI = 'vi';
const LANGUAGE_ES = 'es';
const LANGUAGE_PT = 'pt';
const LANGUAGE_TH = 'th';
const LANGUAGE_CHINESE = 'zh';
const LANGUAGE_CHINESE_LOCALE = 'zh-cn';
const LANGUAGE_CHINESE_T = 'zht';
const LANGUAGE_CHINESE_ALTERNATE = 'zh-tw';

/**
 * cookies
 */
export default {
  OS_VERSION: 'os-version',
  AUTH_TOKEN: 'auth_token',
  AUTH_TOKEN_EXPIRED_TIME: 3600 * 24 * 30,
  AUTH_TOKEN_IN_HEADERS: 'Authorization',
  ORDER_TOKEN: 'order_token',
  COOKIE_LANGUAGE: 'site_lang',
  LANGUAGE: 'site_lang',
  LANGUAGE_EXPIRED_TIME: 3600 * 24 * 365 * 10,
  B_COOKIE: 'b_cookie',
  B_COOKIE_IN_HEADER: 'b-cookie',
  ZIP_CODE: 'NEW_ZIP_CODE',
  IS_LOGIN: 'IS_LOGIN',
  HOT_DISH_DEAL_ID: 'hotdish_deal_id',
  WEBSITE: 'Sayweee.com',
  WEBSITE_LINK: 'https://www.sayweee.com',
  WEEE_STORE: 'weee-store',
  //本字段供大数据埋点使用
  WEEE_SESSION_TOKEN: 'weee_session_token',
  WEEE_SESSION_TOKEN_MAX_AGE: 3600,
  //大数据header头名称
  WEEE_HEADER_SESSION_TOKEN: 'weee-session-token',
  WEEE_APP_TOKEN: 'weee-token',
  WEEE_APP_TOKEN_ANDROID: 'weee_token',
  CI_SESSION: 'ci_session',
  LANG: 'lang',
  DELIVERY_DATE: 'DELIVERY_DATE',
  DELIVERY_DATE_EXPIRE_DTM: 'delivery_date_expire_dtm',
  LAST_WEEE_SESSION_TOKEN: 'last_weee_session_token',
  /**辣度 */
  SPICY_ENUM: {
    /**微辣 */
    spicy1: 'spicy1',
    /**中辣 */
    spicy2: 'spicy2',
    /**重辣 */
    spicy3: 'spicy3'
  },
  IMAGE_CDN: {
    DEV: 'https://cdn01.tb1.sayweee.net',
    PROD: 'https://static.weeecdn.com'
  },
  PRODUCT_FEATURE: {
    SALE: 2,
    MEMBER: 4,
    NEW: 8
  },
  ADDRESS_CITY: 'NEW_ZIP_CITY',
  ZIP_CITY: 'NEW_ZIP_CITY',
  IS_SHIPPING_ORDER: 'is_shipping_order_mobile',
  IS_SHIPPING_ORDER_VAL: {
    IS: '1',
    NO: '0'
  },
  PANTRY_FREE_FEE: 'pantry_free_fee',
  GLOBAL_FREE_FEE: 'global_free_fee',
  PANTRY_FEE: 'pantry_fee',
  SALES_ORG_ID: 'NEW_SALES_ORG_ID',
  SALES_ORG_ID_HEADER: 'WEEE-SALES-ORG-ID',
  ALL_LANGUAGES: [
    { label: 'English', key: LANGUAGE_EN },
    { label: '简体中文', key: LANGUAGE_ZH },
    { label: '繁體中文', key: LANGUAGE_ZHT },
    // { label: 'Español', key: LANGUAGE_ES },
    { label: '한국어', key: LANGUAGE_KO },
    { label: '日本語', key: LANGUAGE_JA },
    { label: 'Tiếng Việt', key: LANGUAGE_VI },
    { label: 'ภาษาไทย', key: LANGUAGE_TH }
  ],
  SHARE_LANUAGES: [
    { label: 'English', key: LANGUAGE_EN },
    { label: '简', key: LANGUAGE_ZH },
    { label: '繁', key: LANGUAGE_ZHT_ALIAS },
    // { label: 'Español', key: LANGUAGE_ES },
    { label: '한국어', key: LANGUAGE_KO },
    { label: '日本語', key: LANGUAGE_JA },
    { label: 'Tiếng Việt', key: LANGUAGE_VI },
    { label: 'ภาษาไทย', key: LANGUAGE_TH }
  ],
  LATINO_LANUAGES: [
    { label: 'English', key: LANGUAGE_EN },
    { label: 'Español', key: LANGUAGE_ES },
    { label: 'Português', key: LANGUAGE_PT }
  ],
  LATINO_SHARE_LANUAGES: [
    { label: 'English', key: LANGUAGE_EN },
    { label: 'Español', key: LANGUAGE_ES },
    { label: 'Português', key: LANGUAGE_PT }
  ],
  EMAIL_NOT_COLLECTED: 'show_collection_email_popup',
  IS_CHANGE_AREADY_SHIP_AREA: 'is_change_aready_ship_area',
  IS_CHANGE_SHIP_AREA: 'is_change_ship_area',
  IS_CHANGE_DELIVERY_AREA: 'is_change_delivery_area',
  LANGUAGE_ZHT_ALIAS: LANGUAGE_ZHT_ALIAS,
  LANGUAGE_ZHT: LANGUAGE_ZHT,
  LANGUAGE_ZH_ALIAS: LANGUAGE_ZH_ALIAS,
  LANGUAGE_ZH: LANGUAGE_ZH,
  LANGUAGE_EN: LANGUAGE_EN,
  LANGUAGE_KO: LANGUAGE_KO,
  LANGUAGE_JA: LANGUAGE_JA,
  LANGUAGE_VI: LANGUAGE_VI,
  LANGUAGE_ES: LANGUAGE_ES,
  LANGUAGE_PT: LANGUAGE_PT,
  LANGUAGE_TH: LANGUAGE_TH,
  LANGUAGE_CHINESE: LANGUAGE_CHINESE,
  LANGUAGE_CHINESE_LOCALE: LANGUAGE_CHINESE_LOCALE,
  LANGUAGE_CHINESE_T: LANGUAGE_CHINESE_T,
  LANGUAGE_CHINESE_ALTERNATE: LANGUAGE_CHINESE_ALTERNATE,
  LANGUAGES: [
    LANGUAGE_ZHT,
    LANGUAGE_ZH,
    LANGUAGE_EN,
    LANGUAGE_KO,
    LANGUAGE_JA,
    LANGUAGE_VI,
    LANGUAGE_ES,
    LANGUAGE_PT,
    LANGUAGE_TH
  ],
  SEARCH_PAGE: 'restaurant_search_page',
  ORDER_SHARE_PAGE: 'order_share',
  HOMEPAGE_BANNER: 'home_page_banner',
  HOMEPAGE_AD: 'home_page_ad',
  APP_SEARCH: '',
  APP_TAB_BAR: 'tab_bar',
  APP_CONTEXT: 'app-context',
  OLD_APP_CONTEXT: 'old-app-context',
  APP_CHANNEL: 'app_channel',
  LANGUAGE_REGEXP_TWO: /^(\/)?(zh-hant|zh-Hant|zht|zh|en|es|ko|ja|vi|pt|th)?/,
  LANGUAGE_REGEXP: /^\/(zh-hant|zh-Hant|zht|zh|en|es|ko|ja|vi|pt|th)/,
  REGISTRATION_SUCCESS: 'registration_success',
  SUCCESS_METHOD: 'success_method',
  LOGIN_SUCCESS: 'login_success',
  STORE_THEME: 'store_theme',
  STORE_INFO: 'store_info',
  IS_SUPPORT_GLOBAL: 'is_support_global',
  GUIDE_HOME_SHIP: 'GUIDE_HOME_SHIP',
  GUIDE_HOME_DELIVERY: 'GUIDE_HOME_DELIVERY',
  GUIDE_HOME_STORE: 'GUIDE_HOME_STORE',
  COOKIE_UPDATE_ADDRESS_ID: 'update_address_id',
  //checkout编辑地址返回不显示popups
  SHOW_CHECKOUT_POPS: 'show_checkout_popups',
  SELECT_ADDRESS: 'select_address',
  //登录注册邀请好友使用
  REFERRER_ID: 'referrer_id',
  REFERRER_ID_HEADER: 'Referrer-Id',
  //返利联盟使用
  REFERRAL_ID: 'referral_id',
  AFFILIATE_REFERRAL_ID: 'affiliate_referral_id',
  SHOW_HAWAII_POPUP: 'event_checkout_show_popup',
  USER_ID: 'user_id',
  UID: 'uid',
  /* 未登录使用, 登录后删除 */
  TEMP_USER_ID: 'temp_user_id',
  IS_AFFILIATE: 'is_affiliate',
  INVITOR_ID: 'invitor_id',
  POST_TYPE: {
    VIDEO: 'video',
    REVIEW: 'review'
  },
  POST_SHORT_TYPE: {
    VIDEO: 'v',
    REVIEW: 'p'
  },
  POST_URL: {
    VIDEO: 'post',
    REVIEW: 'review'
  },
  REFERRER_SOURCE: 'referrer_source',
  LANGUAGE_CHINESE_T_ALIAS: 'zh-Hant',
  AFFILIATE_SHARE_COOKIE: 'me_affiliate_share',
  LANDING_STAMP_EXPIRES: 'landing_stamp_expires',
  WEEE_OFFICIAL_USER_ID: 5044,
  ORDER_PRODUCT_TYPE_TRADE_IN: 'trade_in',
  ORDER_PRODUCT_TYPE_GIFT: 'gift',
  META_CODE_WORKFLOW_STATUS_APPLYING: 'A',
  META_CODE_WORKFLOW_STATUS_REJECT: 'R',
  META_CODE_WORKFLOW_STATUS_FINISHED: 'F',
  META_CODE_WORKFLOW_STATUS_APPROVED: 'P',
  PDP_LANDING_STAMP_EXPIRES: 'pdp_landing_stamp_expires',
  APP_PURCHASE_REMINDER_EXPIRES: 'app_purchase_reminder_expires',
  SHOW_MORE_STORE_TOOLTIP: 'show_more_store_tooltip',
  ORDER_ID: 'ois',
  IS_NEW_PDP: 'is_new_pdp',
  //第一次访问的落地页
  LANDING_URL: 'landing_url',
  COMMON_EXPIRED_TIME: 3600 * 24 * 365 * 4,
  PRE_ORDER_ID: 'pre_order_id',
  EP_PARTNER: 'ep_partner',
  BIND_PHONE_COUPON: 'bind_phone_coupon',
  /** 满折或满减 */
  ACTIVITY_FULL_DISCOUNT: 'full_discount',
  /** 换购 */
  ACTIVITY_TRADE_IN: 'trade_in',
  /** 满赠 */
  ACTIVITY_GIFT: 'gift',
  // promotion partner
  ACTIVITY_PROMOTION_POINT: 'promo_point',
  // tiktok live deal
  TIKTOK_LIVE_DEAL: 'tiktok_live_deal',
  APP_VERSION: 'app-version',
  PAID_W_SOURCES: [
    { value: 8, label: 'Chinese Online Ads' },
    { value: 9, label: 'Chinese Offline Ads' },
    { value: 12, label: 'Web Facebook  Ads' },
    { value: 22, label: 'Web Google Ads' },
    { value: 24, label: 'Bing' },
    { value: 26, label: 'Mediamath' },
    { value: 27, label: 'Impact' },
    { value: 28, label: 'Snapchat' },
    { value: 29, label: 'TikTok' },
    { value: 30, label: 'Chinese Display Ads' },
    { value: 31, label: 'Pinterest' }
  ],
  PUSH_TO_NATIVE: 'pushto=native',
  PUSH_TO_NATIVE_OBJECT: {
    KEY: 'pushto',
    VALUE: 'native'
  },
  IS_NEW_ONBOARDING: 'is_new_onboarding',
  IS_AGREE_PRIVACY_TERMS: 'isAgreePrivacyTerms',
  DEVICE_ID: 'device-id',
  BROWSER_TYPE: 'Browser-Type',
  BROWSER_TYPE_MAP: {
    TIKTOK: 'tiktok',
    WECHAT: 'wechat',
    ALI: 'alipay'
  },
  ZIPCODE_HEADER: 'zipcode',
  DEAL_ID: 'deal_id',
  IMGAGE_COMMON_ALT: 'Weee! - Groceries Delivered',
  GLOBAL_VENDERD_LIST: 'global_vender_list',
  ORDER_LIST_CACHE: 'order-list-store',
  VIEW_ID: 'view_id',
  PROFILE_INFO: 'profile_info',
  ORDER_NOTE: 'orderNote',
  REFERRER_PAGE_KEY: 'referrer_page_key',
  REFERRER_PAGE_URL: 'referrer_page_url',
  MEMBER_REBATE_PERCENT: 5,
  MEMBER_MAX_REBATE_PERCENT: 10,
  PROD_FEATURE_BIT_SALE: 2,
  //是否已经微信登录过
  IS_WECHAT_LOGIN: 'is_wechat_login',
  //首页是否能够切换日期
  IS_HOME_CHANGE_DATE: 'is_home_change_date',
  TRADE_IN_LIMIT_AMOUNT: 68,
  MAXIMUM_TRADE_IN_PURCHASE_PER_ITEM_LIMIT: 1,
  ACTIVITY_CENTER_CACHE_KEY: 'activity_center_cache_key',
  ACTIVITY_CENTER_CACHE_TIME: 4 * 3600,
  ACTIVITY_CENTER_CACHE_DATA_KEY: 'activity_center_cache_data_key',
  WEEE_EDITOR_USER_ID: 13589,
  IS_SUPPORT_CHANGE_DATE: 'is_support_change_date',
  SHOULD_SHOW_ADS_LIST: 'should_show_ads_list',
  POPUP_CREATE_ACCOUNT_SESSION: 'popup_create_account_session',
  POPUP_CREATE_ACCOUNT_EMAIL: 'popup_create_account_email',
  EMAIL_COLLECT_POPUP_SHOWED: 'email_collct_popup_showed',
  FIRST_PAGE_URL_IN_APP: 'first_page_url_in_app',
  FIRST_STORE_SELECT_FOR_MAIN: 'first_store_select_for_main',
  FTU_FLAGS: {
    SHOW_NO_SCREEN: 0,
    SHOW_FIRST_SCREEN: 2,
    SHOW_SECOND_SCREEN: 4,
    SHOW_THIRD_SCREEN: 8,
    SHOW_ALL_SCREEN: 14,
    DELAY_THREE_SECONDS: 16,
    ALWAYS_SHOW: 32
  },
  FTU_SHOW_TIME: 'ftu_show_time',
  FTU_SHOW_COUNT: 'ftu_show_count',
  IMAGE_CDN_PREFIX: 'https://img06.weeecdn.com/front-end/image/000/000/',
  POPUP_ACCOUNT_SET_PASSWORD: 'popup_account_set_password',
  TIME_ZONE: 'timezone',
  COMBINE_SHIPPING_FREE: 'combine_shipping_free',
  /** 与 weee_session_token 绑定，记录 Open App 弹窗成功展示次数（JSON: { t, c }） */
  OPEN_APP_POPUP_IMPRESSION: 'open_app_popup_impression',
  MAX_OPEN_APP_POPUP_IMPRESSIONS: 2,
  GROUP_ORDER_KEY: 'group_order_key',
  GROUP_ORDER_VENDOR_ID: 'group_order_vendor_id',
  SHOW_GROUP_ORDER_MOVE_TIP_ONCE: 'show_group_order_move_tip_once',
  FTU_COOKIE: 'ftu_cookie',
  FTU_COOKIE_EXPIRED_TIME: 3600 * 24 * 365 * 4,
  IS_POPPED_FREEBIE_INTRODUCING: 'is_popped_freebie_introducing',
  WEEE_DATE: 'Weee-Date',
  WEEE_ZIPCODE: 'Weee-Zipcode',
  H5_DISCOUNT_INFO: 'h5_discount_info',
  H5_UPDATE_DISCOUNT_INFO: 'h5_update_discount_info',
  REFERRAL_ID_AF: 'referral_id_af',
  REFERRAL_ID_EXPIRED_TIME: 60 * 60 * 2,
  B_COOKIE_EXPIRED_TIME: 3600 * 24 * 365 * 4,
  WEEE_GLOBAL_STATE: 'weee-global-state',
  GSOPTOUT: 'gsoptout',
  // 手动退出cookie过期时间15分钟
  GSOPTOUT_MAX_AGE: 900,
  STUDENT_SOURCE: 'student',
  EDU_SESSION: 'edu_session',
  NAV_CATEGORY_SCROLL_CONTAINER_ID: 'navctid',
  MODAL_Z_INDEX: 1002,
  // edu_session过期时间1小时
  EDU_SESSION_MAX_AGE: 3600,
  WEEE_CHANNEL: 'weee-channel',
  FIRST_STORE_SELECT: 'first_store_select',
  HAS_VISITED_STUDENT_BENEFITS: 'has_visited_student_benefits'
};
